import { getInstalledApplications } from '@app/routes/apps/services/endpoints';
import { setAuthHeader } from '@app/routes/apps/services/instance';
import { useReadDashboardSharedState } from '@hopin-team/dashboard-shared-react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useSalesforceInstalled = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const orgId: string = useReadDashboardSharedState('org_id') || '';
  const authToken: string =
    useReadDashboardSharedState('user_auth_token') || '';

  useEffect(() => {
    if (authToken) {
      setAuthHeader(authToken);
    }
  }, [authToken]);

  const { data: applications = [], isLoading } = useQuery(
    ['applications', orgId],
    () => getInstalledApplications(orgId),
    {
      enabled: enabled && Boolean(orgId) && Boolean(authToken),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  const isSalesforceInstalled = applications.some(
    ({ id, attributes }) =>
      id === 'salesforce' || attributes.slug === 'salesforce',
  );

  return { isSalesforceInstalled, isLoading };
};
